import React from 'react';
import ProjectsContainer from '../components/projects.container';

/** Every project the user has, and the way into one. */
const ProjectsPage: React.FC = () => <ProjectsContainer />;

export default ProjectsPage;
